<template>
    <!-- p-l-0/p-r-0: wiersze towarow maja zaczynac sie w tej samej linii co pola
         pozostalych sekcji formularza - bez tego dodatkowe zagniezdzenie kolumn
         przesuwalo cala sekcje o szerokosc odstepu kolumny w prawo -->
    <div class="col-12 p-l-0 p-r-0">
        <MarginItemRow
            v-for="(item, index) in items"
            :key="index"
            :canDeleteItem="canDeleteItem"
            :disabled="disabled"
            :errors="errors"
            :item="item"
            :additionalFields="additionalFields"
            :gtus="gtus"
            :procedures="procedures"
            :itemIndex="index"
            :isSymbolVisible="isSymbolVisible"
            :standardItems="standardItems"
            :requiredFields="requiredFields"
            :permissionsAccess="permissionsAccess"
            :vatRates="vatRates"
            @addStandardItem="addStandardItem"
            @inputs="$emit('itemInput', {index, ...$event})"
            @itemChanged="emitSummaries"
            @removeItem="$emit('removeItem', index)"
        />

        <hr>

        <MarginRoundingRow :roundings="roundings"/>

        <MarginSummaryRow
            :disabled="disabled"
            :errors="errors"
            :sums="summaries"
            @addNewItem="$emit('addNewItem')"
        />
    </div>
</template>

<script>
import MarginItemRow from "./MarginItemRow";
import hasErrors from "../../../../mixins/hasErrors";
import hasVatRates from "../../../../mixins/hasVatRates";
import MarginRoundingRow from "./MarginRoundingRow";
import MarginSummaryRow from "./MarginSummaryRow";
import {forEach, groupBy, round} from "lodash";
import inputEmit from "../../../../mixins/inputEmit";
import hasRequiredFields from "../../../../mixins/hasRequiredFields";
import hasPermissions from "../../../../mixins/hasPermissions";

export default {
    name: "MarginItemsSection",
    components: {MarginSummaryRow, MarginRoundingRow, MarginItemRow},
    mixins: [hasErrors, hasVatRates, inputEmit, hasRequiredFields, hasPermissions],
    props: {
        items: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isSymbolVisible: {
            type: Number,
            default: 0,
        },
        standardItems: {
            type: Array,
            default: [],
        },
        additionalFields: {
            type: Array,
            default: () => [],
        },
        gtus: {
            type: Array,
            default: () => [],
        },
        procedures: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            roundings: {
                margin_vat: 0,
            },
            summaries: {
                gross: 0,
                margin: 0,
                margin_vat: 0,
            },
        };
    },
    computed: {
        groupedByVatRate() {
            return groupBy(this.items, item => item.margin_vat_rate);
        },
        canDeleteItem() {
            return this.items.length > 1;
        },
        sumItemsGrossAmount() {
            return !isNaN(this.getSum('gross_amount')) ? this.parseMoney(this.getSum('gross_amount')) : this.parseMoney(this.getSum('net_amount'));
        },
        sumItemsMarginAmount() {
            return this.parseMoney(this.getSum('margin'));
        },
        sumItemsMarginVatAmount() {
            let sum = 0;
            const groupedItems = this.groupedByVatRate;
            Object.keys(groupedItems).forEach((key) => {
                const groupMarginSum = groupedItems[key].reduce((prevVal, item) => prevVal + item.margin, 0);
                const vatRateAmount = this.getVatRateAmount(parseInt(key));

                sum += round(round((groupMarginSum * (vatRateAmount / (1 + vatRateAmount))), 10), 2);
            });

            return this.parseMoney(sum);
        },
        roundingsMarginVat() {
            return this.rounding('margin_vat');
        },
    },
    methods: {
        getSum(field) {
            return this.items.reduce((prevVal, item) => prevVal + item[field], 0);
        },
        addStandardItem(index){
            this.$emit('addStandardItem', index)
        },
        parseMoney(number) {
            number = this.$options.filters.money(number);
            return this.$options.filters.floatMoney(number);
        },
        calculateSummary() {
            this.summaries.gross = this.sumItemsGrossAmount;
            this.summaries.margin = this.sumItemsMarginAmount;
            this.summaries.margin_vat = this.sumItemsMarginVatAmount;
        },
        emitSummaries() {
            this.calculateSummary();
            this.calculateRoundings();
            this.emitInput('gross_amount', this.summaries.gross);
            this.emitInput('net_amount', this.summaries.gross);
            this.emitInput('vat_margin_amount', this.summaries.margin_vat);
        },
        calculateRoundings() {
            this.roundings.margin_vat = this.roundingsMarginVat;
        },
        rounding(field) {
            const itemsRowSum = this.getSum(`${field}_amount`);
            const itemComputedSum = this.summaries[field];
            let result = itemComputedSum - itemsRowSum;
            result = Math.round(result * 100) / 100;

            return result;
        },
        initSummaries(summaries) {
            forEach(summaries, (value, name) => this.summaries[name] = value);
        },
        sumVatAmountAndEmitSummaries() {
            this.summaries.vat = this.sumItemsVatAmount;
            this.emitSummaries(false);
        },
    },
};
</script>
